import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      display: 'flex',
      position: 'static',
      width: '100%',
      height: '100%',
    },
    elementsContainer: {
      top: 0,
      height: '100vh',
      position: 'sticky',
    },
    elements: {
      display: 'flex',
      height: '100%',
    },
    content: {
      display: 'flex',
      width: '100%',
      height: '100%',
    },
    muiContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 0,
      paddingRight: 0,

      [muiTheme.breakpoints.up('md')]: {
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      },
    },
    child: {
      [muiTheme.breakpoints.up('sm')]: {
        flex: '0 0 50%',
        width: '50%',
      },
    },
    dots: {},
    fixedDots: {},
    headings: {},
    overlay: {
      position: 'absolute',
      width: '100%',
      left: 0,
      display: 'flex',
      alignItems: 'flex-end',
      alignContent: 'flex-end',
      pointerEvents: 'none',
      height: '100%',
      top: 0,

      [muiTheme.breakpoints.up('md')]: {
        height: '100%',
        top: 0,
      },

      '&:after': {
        [muiTheme.breakpoints.up('md')]: {
          left: '-32px',
        },
      },
    },
    interactiveArea: {
      height: '150vh',
    },
    segments: {},
    line: {
      height: '100%',
      position: 'absolute',
      left: '-0.5px',

      [muiTheme.breakpoints.down('xs')]: {
        height: 'calc(100vh - 58px)',
        left: '-32px',
      },
    },
  }),
  { name: 'GenHeroHomepageContent' },
);

export default useStyles;
